var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageFilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.174 0H4.82617C2.61703 0 0.826172 1.79086 0.826172 4V22C0.826172 24.2091 2.61703 26 4.82617 26H30.174C32.3831 26 34.174 24.2091 34.174 22V4C34.174 1.79086 32.3831 0 30.174 0Z",
    fill: "currentColor",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1313_1215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.174 0.565186H4.82617C2.61703 0.565186 0.826172 2.35605 0.826172 4.56519V22C0.826172 24.2091 2.61703 26 4.82617 26H30.174C32.3831 26 34.174 24.2091 34.174 22V4.56519C34.174 2.35605 32.3831 0.565186 30.174 0.565186Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1313_1215)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.34272 14.1571C4.31836 12.3255 7.74435 11.8986 10.0935 13.1662L23.0967 20.1826C25.5269 21.4939 25.9017 24.1274 23.9338 26.0646L14.2591 35.5883C12.637 37.185 9.86845 37.8492 7.56857 37.1292C0.607541 34.9498 -12.891 30.1705 -10.095 26.6442C-7.65526 23.5673 -1.57807 17.7919 2.34272 14.1571Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2821 11.3463C16.2578 9.51475 19.6838 9.08783 22.0329 10.3554L35.0362 17.3718C37.4664 18.6831 37.8411 21.3166 35.8732 23.2538L26.1985 32.7775C24.5765 34.3742 21.8079 35.0385 19.508 34.3184C12.547 32.139 -0.95151 27.3597 1.84448 23.8334C4.28417 20.7565 10.3614 14.9812 14.2821 11.3463Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9992 7.91298C12.2478 7.91298 13.26 6.90075 13.26 5.65211C13.26 4.40346 12.2478 3.39124 10.9992 3.39124C9.75051 3.39124 8.73828 4.40346 8.73828 5.65211C8.73828 6.90075 9.75051 7.91298 10.9992 7.91298Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFilePlaceholder);
export default __webpack_public_path__ + "static/media/image-file-placeholder.9d26ae6b2272ac92d64ccaff8e714127.svg";
export { ForwardRef as ReactComponent };